<template>
  <div class="container-fluid">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body text-center">
          <input class="inputNumberClient" ref="inputNumberClient" type="number" v-model="clientNumber" placeholder="Numero de cliente" min="0" v-on:keyup.enter="searchClient"  autofocus/>
          <button class="ml-2 btn btn-danger" @click="searchClient()" :readonly="esperar">Buscar</button>
          <!-- <button class="ml-2 btn btn-danger" @click="imprimir()">print</button> -->
        </div>
      </div>
      <div class="card" v-if="client.id_client > 0">
        <div class="card-body">
          <div class="row">
             <span class="mr-4">Número de cliente: <b>{{client.key_client}}</b></span>
             <span class="mr-4">Nombre: <b>{{client.fullname}}</b></span>
             <span>Teléfono: <b>{{client.phone}}</b></span>
          </div>
          <div class="row justify-content-center mt-4">
            <h6>Cantidad de Productos: {{jsondata.length}}</h6>
            <h6 class="ml-4">Total: $ {{totalProductos | formatNumberCurrency}} pesos</h6>
          </div>
          <div class="row justify-content-center mt-3">
            <h6><span style="color:red ">Cantidad de Faltantes: {{jsondataFaltantes.length}}</span></h6>
          </div>
        </div>
      </div>
      <div class="card" v-if="client.id_client > 0">
        <div class="card-body text-center">
          <input ref="searchBarcode" class="inputBarCode" type="text" v-model="barcodeSearch" placeholder="Codigo de barras" min="0" v-on:keyup.enter="searchElement"/>
        </div>
        <div class="text-left">
          <h4><b>Folio de venta: # {{ nextSale }}</b></h4>
          <button class="btn btn-info ml-3" style="font-size: 12px;" @click="openModalDevolution()">Nuevo Vale</button>
        </div>
        <div class="text-right">
          <b-form-select
            v-model="selectedAlmacen"
            :options="almacenes"
            class="mb-3 col-lg-2"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-select>
        </div>
      </div>
      <!-- {{jsondata}} -->
      <div class="card" v-if="client.id_client > 0">
        <div class="card-body">
            <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="jsondata"
                :row-style-class="rowStyleClassFn"
                :totalRows="totalRecords"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'dates'" class="text-center" style="text-align: center;">
                  <p style="font-size: 8px;">{{ props.row.delivery_date }}</p>
                  <p style="font-size: 8px;">Compra: {{ props.row.date_buy }}</p>
                </span>
                <span v-if="props.column.field == 'actions'" class="text-center" style="text-align: center;">
                  <!-- {{jsondata[props.index]}} -->
                  <button class="btn" style="background: red; color: white; font-size: 10px;" @click="confirmCancelComision(props)" v-if="!jsondata[props.index].cancelado && jsondata[props.index].encontrado !== 1">Cancelar C/Comision</button>
                  <!-- <button class="btn ml-2" style="background: orange; color: white; font-size: 10px;" @click="confirmCancel(props)" v-if="!jsondata[props.index].cancelado && jsondata[props.index].encontrado !== 1">Cancelar</button> -->
                  <span v-if="jsondata[props.index].cancelado" style="color: red">
                    Cancelado
                  </span>
                </span>
                <span v-if="props.column.field == 'descuento'" class="text-center" style="text-align: center;">
                <div class="input-group mb-2" v-if="props.row.encontrado !== 1">
                <!-- {{props.row}} -->
                  <input type="number" class="form-control" id="inlineFormInputGroup"  v-model="props.row.porcentaje_descuento" placeholder="Porcenage de descuento" @change="calculeDescount(props.row)" style="width: 30px !important; padding: 0px 5px 0px;" :readonly="jsondata[props.index].cancelado || myRoleId !== 1">
                  <div class="input-group-prepend">
                    <div class="input-group-text">%</div>
                  </div>
                </div>
                <div v-else>
                  {{props.row.porcentaje_descuento}} %
                </div>
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
            </vue-good-table>
            <div class="container">
              <div class="row">
                <div class="col align-self-start mt-4">
                </div>
                <!-- <div class="col align-self-center">
                </div> -->
                <div class="col align-self-end mt-3">
                  <table class="breakdownTable">
                    <tr v-for="(desgloce, key) in tableDesgloce" :key="key">
                      <td>{{desgloce.name}}</td>
                      <td>{{desgloce.value}}</td>
                    </tr>
                    <tr>
                      <td><b>Total de la compra:</b></td>
                      <td><b>$ {{total  | formatNumberCurrency}}</b></td>
                    </tr>
                    <tr v-for="(item, index) in ticket" :key="index">
                      <td><b>Total de vale {{item.ticket.invoice}}:</b></td>
                      <td><b>$ {{item.saldo  | formatNumberCurrency}}</b></td>
                    </tr>
                    <!-- <pre>{{ notas }}</pre> -->
                    <tr v-for="(item, index) in notas" :key="index">
                      <td><b>Nota de credito {{item.barcode}}:</b></td>
                      <td><b style="color: red">$ {{item.used | formatNumberCurrency}}</b></td>
                      <td><b style="color: green">$ {{item.disponible | formatNumberCurrency}}</b></td>
                    </tr>
                    <tr v-if="saldoFavor > 0">
                      <td><b>Saldo a favor:</b></td>
                      <td><b>$ {{saldoFavor}}</b></td>
                    </tr>
                    <tr>
                      <td><b>Total a pagar:</b></td>
                      <td><b>$ {{totalSell  | formatNumberCurrency}}</b></td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="container mt-5">
              <div class="row justify-content-end">
                <div class="col-4" v-if="totalSell > 0 || notas.length > 0">
                  <button type="button" class="btn btn-success" @click="setBuy">Realizar Venta</button>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="card" v-if="client.id_client > 0">
        <div class="card-header">
          FALTANTES

          <div class="row justify-content-center">
          </div>
          <div class="row justify-content-end">
            <jsonExcel :data="jsondataFaltantes"
                class="btn btn-secondary ml-2"
                :fields= "{
                  'Id': 'id_order',
                  'Producto': 'product',
                  'Proveedor': 'provider',
                  'Catalogo': 'catalogo',
                  'Modelo': 'modelo',
                  'Cantidad': 'cantidad',
                  'Comentario': 'comentario',
                  'Talla': 'numero',
                  'Fecha': 'delivery_date'
                }"
                worksheet="FALTANTES"
                name="FALTANTES.xls"
              >
                Descargar a Excel
              </jsonExcel>
            <button class="btn btn-danger m-2" @click="cancelAllFaltantes">
              <b>CANCELAR TODOS LOS FALTANTES</b>
            </button>
          </div>
        </div>
        <!-- {{jsondataFaltantes}} -->
        <div class="card-body">
            <vue-good-table
                mode="remote"
                :ref="'grid'"
                :columns="columnsFaltantes"
                :rows="jsondataFaltantes"
                :row-style-class="rowStyleClassFn"
                :totalRows="totalRecords"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
            >
             <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <b-dropdown id="dropdown-1" text="Acciones" class="m-md-2">
                    <b-dropdown-item @click="volverPedir(props)">
                      <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Pedir de Nuevo
                    </b-dropdown-item>
                    <b-dropdown-item @click="cancelarPedido(props)" style="background: red; color: white">
                      <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Cancelar
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-if="props.column.field == 'cantidad'">
                  <input type="text" v-model="props.row.cantidad">
                </span>
                <span v-else-if="props.column.field == 'catalogo'">
                  <input type="text" v-model="props.row.catalogo">
                </span>
                <span v-else-if="props.column.field == 'marca'">
                  <input type="text" v-model="props.row.marca">
                </span>
                <span v-else-if="props.column.field == 'modelo'">
                  <input type="text" v-model="props.row.modelo">
                </span>
                <span v-else-if="props.column.field == 'color'">
                  <input type="text" v-model="props.row.color">
                </span>
                <span v-else-if="props.column.field == 'numero'">
                  <input type="text" v-model="props.row.numero">
                </span>
                <span v-else-if="props.column.field == 'product'">
                  {{props.row.product}}
                </span>
                <span v-else-if="props.column.field == 'delivery_date'">
                  <input type="text" v-model="props.row.delivery_date">
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
            </vue-good-table>
        </div>
      </div>
      <ticket :ticket="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrint"/>
      <devolutionTicket :folio="abono.folio" :enterprise="enterpriseData.name" :print="countPrintDevolution"/>
      <div class="mt-3">
        <!-- IMPRESION ABONO -->
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          filename = "abono.pdf"
          :paginate-elements-by-height="300"
          :pdf-quality="2"
          :manual-pagination="true"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          @beforeDownload="beforeDownload($event)"
          ref="html2PdfAbono"
        >
          <section slot="pdf-content" style="width: 80mm !important;">
            <div class="container ticket" style="width: 80mm !important">
              <div class="row mt-1 justify-content-center">
                <div class="col-lg-11 text-center line1">
                  <p>Mundo del catalogo</p>
                  <p>{{enterpriseData.name}}</p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 mt-1 text-center line1">
                  <p>Nota de Credito</p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 text-center">
                  <VueBarcode :value="abono.barcode" width="1" :options="barcode_option" >
                  Show this if the rendering fails..
                </VueBarcode>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-lg-6">
                  <p>Fecha de aplicación: {{today}}</p>
                </div>
              </div>
              <div class="mt-2 bodyPrintAbono line1">
                <p><b>Cliente: </b></p>
                <p>{{abono.client_name}}</p>
                <p>ATENDIO: {{user.name + ' ' + user.last_name_1 + ' ' + user.last_name_2}}</p>
                <div class="mt-1">
                  <table class="tableXD">
                    <tr>
                      <th>Descripción</th>
                      <th>Monto</th>
                      <th>Monto utilizado</th>
                      <th>Total disponible</th>
                    </tr>
                    <tr>
                      <td class="line1">{{abono.descripcion}}</td>
                      <td class="line1">$ {{abono.amount | formatNumberCurrency}}</td>
                      <td class="line1">$ {{abono.amount_use | formatNumberCurrency}}</td>
                      <td class="line1">$ {{abono.disponible | formatNumberCurrency}}</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align: right;">Total: </td>
                      <td>$ {{abono.disponible | formatNumberCurrency}}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="row justify-content-center mt-4">
                <div class="col-lg-10 text-center footerTicket line1">
                  <p>Gracias por su preferencia</p>
                  <p>Teléfonos</p>
                  <p v-for="(p, index) in footer.phones" :key="index">{{p.phone}}</p>
                </div>
              </div>
              <div class="row footerTicket mt-4">
                <p>{{footer.texto}}</p>
              </div>
            </div>
          </section>
        </vue-html2pdf>
      </div>
    </div>
    <modal name="alacenElements" :adaptive="true" :scrollable="true" width="1100" height="auto" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('alacenElements')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center container">
        <h5>Productos de almacen "{{selectedAlmacen}}"</h5>
        <div class="row mt-5 mb-5 justify-content-center" >
          <div class="col-lg-11">
            <vue-good-table
              max-height="600px"
              :columns="columnsAlmacen"
              :rows="productosAlmacen"
              :row-style-class="rowStyleClassFn"
              :totalRows="totalRecords"
              styleClass="vgt-table bordered"
              @on-column-filter="onColumnFilter"
              compactMode
            >
             <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'cantidad'">
                    <input type="number" class="form-control" :min="1" v-model="props.row.cantidad" :max="props.row.stock" placeholder="Unidades" @change="calculeCantidadAlmacen(props.row, props.row.cantidad)" style="width: 60px !important">
                </span>
                <span v-else-if="props.column.field == 'appli_mayoreo'">
                  <div>
                    <input type="checkbox" id="horns" name="horns" v-model="props.row.apply_mayoreo" class="form-control" @change="applyMayoreo(props.row)"/>
                  </div>
                </span>
                <span v-else-if="props.column.field == 'actions'">
                  <button class="btn btn-purple" @click="addCompraAlmacen(props.row)">Vender</button>
                </span>
                <span v-else-if="props.column.field == 'descuento'">
                  <div class="input-group mb-2">
                    <input type="number" class="form-control descuentoInpit" id="inlineFormInputGroup" :min="0" v-model="props.row.porcentaje_descuento" placeholder="Porcenage de descuento" @change="calculeDescountAlmacen(props.row)" style="width: 60px !important" :readonly="myRoleId !== 1">
                    <div class="input-group-prepend">
                      <div class="input-group-text">%</div>
                    </div>
                  </div>
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </modal>
    <modal-pago
      :totalVenta="totalSell"
      @confirmado="finalizarVentaEnBaseDatos"
    />
    <!-- <modal name="confirmBuy" :adaptive="true" :scrollable="true" height="700"  width="700" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('confirmBuy')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center container mt-5">
        <h2>Confirmación de compra</h2>
        <div class="text-center mt-5" style="margin:auto; font-size: 18px;">
          <span><b>Total a pagar: $ {{totalSell  | formatNumberCurrency}}</b></span>
        </div>
        <div class="row justify-content-center mt-5 mb-5">
          <div class="col-auto">
            <span class="text-left"><b>EFECTIVO</b></span>
            <label class="sr-only" for="inputEfectivo">Efectivo</label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">$</div>
              </div>
            <input type="number" ref="totalPagoEfectivo" id="inputEfectivo" v-model="totalPagoEfectivo" style="text-align:right;">
            </div>
          </div>
          <div class="col-auto">
            <span class="text-left"><b>TARJETA</b></span>
            <label class="sr-only" for="inputEfectivo">Tarjeta</label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">$</div>
              </div>
            <input type="number" ref="totalPagoTarjeta" id="totalPagoTarjeta" v-model="totalPagoTarjeta" style="text-align:right;">
            </div>
          </div>
          <div class="col-auto">
            <span class="text-left"><b>TRANSFERENCIA</b></span>
            <label class="sr-only" for="inputEfectivo">Transferencia</label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">$</div>
              </div>
            <input type="number" ref="totalPagoTransferencia" id="totalPagoTransferencia" v-model="totalPagoTransferencia" style="text-align:right;">
            </div>
          </div>
        </div>
        <div class="mt-3" v-if="pagoVenta.faltante > 0">
          <span class="red"><b>Faltante: $ {{ pagoVenta.faltante | formatNumberCurrency }}</b></span>
        </div>
        <div class="mt-3" v-if="pagoVenta.cambio > 0">
          <span class="greenChange"><b>Cambio: $ {{ pagoVenta.cambio | formatNumberCurrency }}</b></span>
        </div>
        <div class="row mt-3 mr-4 justify-content-end">
          <table>
            <tr class="" v-if="totalAbonos > 0">
              <th style="font-size: 15px;">Abonos:</th>
              <th style="font-size: 15px;" class="text-rigth">$ {{totalAbonos | formatNumberCurrency}}</th>
            </tr>
            <tr class="" v-if="pagoVenta.comision > 0">
              <th class="text-left" style="font-size: 15px;">Comision:</th>
              <th style="font-size: 15px;" class="text-rigth">$ {{pagoVenta.comision | formatNumberCurrency}}</th>
            </tr>
            <tr class="text-left">
              <td style="font-size: 15px;">Total:</td>
              <td style="font-size: 15px;" class="text-rigth"> $ {{totalSell + pagoVenta.comision | formatNumberCurrency}}</td>
            </tr>
          </table>
        </div>
        <div class="mt-4" v-if="pagoVenta.pagado">
          <button type="button" class="btn btn-success" @click="confirmBuy" :disabled="disabled">Realizar Venta</button>
        </div>
      </div>
    </modal> -->

    <modal name="devolutions" :adaptive="true" :scrollable="true" height="700"  width="700" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('devolutions')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center container" style="height: 75vh; overflow: auto;">
        <Devolutions :clienteProp="{key_client: this.client.key_client}" :printFolio="printValue"/>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import moment from 'moment'
import { BDropdown, BDropdownItem, BFormSelect } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'
import Devolutions from '@/components/orders/Devolutions'
import ticket from './ticket.vue'
import JsonExcel from 'vue-json-excel'
import devolutionTicket from './devolutionTicket.vue'
import ModalPago from './ModalPayment.vue'
moment.locale('es')
export default {
  mixins: [formatData],
  components: {
    JsonExcel,
    VueBarcode,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    VueHtml2pdf,
    BFormSelect,
    Devolutions,
    ticket,
    devolutionTicket,
    ModalPago
  },
  data () {
    return {
      efectivox: 0,
      tarjetax: 0,
      transferenciax: 0,
      printValue: 0,
      disabled: false,
      esperar: false,
      countPrint: 0,
      countPrintDevolution: 0,
      ticketDeCompra: 0,
      nextSale: 0,
      today: moment().format('YYYY-MM-DD'),
      selectedAlmacen: 'CLIENTES',
      almacenSeleccionado: [],
      footer: {
        phones: [],
        texto: ''
      },
      almacenes: [
        { item: 'A', name: 'Option A' },
        { item: 'B', name: 'Option B' },
        { item: 'D', name: 'Option C', notEnabled: true },
        { item: { d: 1 }, name: 'Option D' }
      ],
      barcode_option: {
        format: 'codabar',
        lineColor: '#0aa',
        width: 1,
        height: 45
      },
      enterpriseData: [],
      tableDesgloce: [],
      notas: [],
      cancelaciones: [],
      ultimaVentaReales: {
        amount: 0,
        descuento: 0
      },
      ultimaVenta: [],
      pagaEnEfectivo: true,
      pagaConTarjeta: true,
      pagaConTransferencia: true,
      comisionTarjeta: 0,
      totalProductos: 0,
      cambio: 0,
      totalPagoEfectivo: 0,
      totalPagoTarjeta: 0,
      totalPagoTransferencia: 0,
      totalSell: 0,
      totalAbonos: 0,
      abono: [],
      saldoFavor: 0,
      ticket: [],
      showInputVale: false,
      valeNumero: 0,
      checkboxVale: false,
      total: 0,
      totalShow: 0,
      barcodeSearch: '',
      client: {
        id_cliente: 0,
        fullname: '',
        phone: ''
      },
      isLoading: false,
      clientNumber: '',
      totalRecords: 0,
      jsondata: [],
      jsondataFaltantes: [],
      productosAlmacen: [],
      columns: [
        {
          label: 'Usuario',
          field: 'fullnameUser'
        },
        {
          label: 'Codigo',
          field: 'barcode'
        },
        {
          label: 'Proveedor',
          field: 'provider'
        },
        {
          label: 'Catalogo',
          field: 'catalogo'
        },
        {
          label: 'Producto',
          field: 'product'
        },
        {
          label: 'Fechas',
          field: 'dates'
        },
        {
          label: 'Comentarios',
          field: 'comentario'
        },
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Precio',
          field: 'precio',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Descuento',
          field: 'descuento'
        },
        {
          label: 'Total',
          field: 'total',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Cancelar',
          field: 'actions'
        }
      ],
      columnsAlmacen: [
        {
          label: 'Producto',
          field: 'modelo',
          filterOptions: {
            placeholder: 'Modelo',
            enabled: true
          }
        },
        {
          label: 'En Stock',
          field: 'stock',
          width: '60px',
          filterOptions: {
            placeholder: 'Modelo',
            enabled: true
          }
        },
        {
          label: 'Proveedor',
          field: 'provider',
          width: '120px',
          filterOptions: {
            placeholder: 'Modelo',
            enabled: true
          }
        },
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Menudeo',
          field: 'precio',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Mayoreo',
          field: 'venta_mayoreo',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Vender mayoreo',
          field: 'appli_mayoreo'
        },
        {
          label: 'Descuento',
          field: 'descuento'
        },
        {
          label: 'Total',
          field: 'total',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Acciones',
          field: 'actions'
        }
      ],
      columnsFaltantes: [
        {
          label: 'Usuario',
          field: 'fullnameUser'
        },
        {
          label: 'Producto',
          field: 'product'
        },
        {
          label: 'Proveedor',
          field: 'provider'
        },
        {
          label: 'Catalogo',
          field: 'catalogo'
        },
        {
          label: 'Marca',
          field: 'marca'
        },
        {
          label: 'Modelo',
          field: 'modelo'
        },
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Comentarios',
          field: 'comentario'
        },
        {
          label: 'Talla',
          field: 'numero'
        },
        {
          label: 'Fecha',
          field: 'delivery_date'
        },
        {
          label: 'Acciones',
          field: 'actions',
          tdClass: 'text-center'
        }
      ],
      htmlToPdfOptions: {
        margin: 0,
        // margin: 0,
        // image: {
        //   type: 'jpeg',
        //   quality: 0.98
        // },
        // enableLinks: false,
        html2canvas: {
          scale: 3,
          useCORS: true
        }
        // jsPDF: {
        //   unit: 'mm',
        //   format: 'b10',
        //   orientation: 'portrait'
        // }
      }
    }
  },
  methods: {
    exportAsExcel (i) {
      console.log(this.$refs, i)
      // console.log(this.$refs[i][0], i)
      const format = 'xlsx'
      const exportSelectedOnly = true
      const filename = 'FALTANTES - ' + moment().format('YYYY-MM-DD')
      this.$refs[i][0].exportTable(format, exportSelectedOnly, filename)
    },
    applyMayoreo (row) {
      const apply = row.apply_mayoreo
      console.log(row)
      this.productosAlmacen.find(el => {
        if (el.id_order === row.id_order) {
          el.apply_mayoreo = apply
          if (row.apply_mayoreo) {
            el.total = (el.venta_mayoreo - ((row.porcentaje_descuento / 100) * el.venta_mayoreo)) * row.cantidad
          } else {
            el.total = (el.precio - ((row.porcentaje_descuento / 100) * el.precio)) * row.cantidad
          }
        }
      })
    },
    formatCurrencyX (val) {
      return '$ ' + this.$formatNumberCurrency(val)
    },
    confirmCancelComision (prop) {
      // console.log(prop)
      this.$dialog.confirm(`
        <div class="row justify-content-center">
          <div class="col-lg-10 text-center">
            <h4 style="color:red"><b>Por favor, confirma que deseas cancelar la compra de este producto. <br> y cobrar una comisión por la cancelación</b></h4>
          </div>
        </div>
      `)
        .then(async () => {
          // console.log(this.jsondata[prop.index])
          this.jsondata[prop.index].cancelado = true
          this.tableDesgloce.push({
            id_order: this.jsondata[prop.index].id_order,
            name: 'Cancelacion',
            value: (prop.row.precio * 10 / 100) // cobro del 10 %
          })
          // this.totalShow += (prop.row.precio * 10 / 100)
          this.cancelaciones.push({
            code: prop.row.barcode,
            id_order: prop.row.id_order,
            total: prop.row.total
          })
          await this.calculateTotal()
        })
        .catch((err) => {
          console.log('presiono cancelar confirmationDialog', err)
        })
    },
    async confirmCancel (prop) {
      // console.log(prop)
      this.$dialog.confirm(`
        <div class="row justify-content-center">
          <div class="col-lg-10 text-center">
            <h4 style="color:red"><b>Por favor, confirma que deseas cancelar la compra de este producto.</b></h4>
          </div>
        </div>
      `)
        .then(async () => {
          this.jsondata[prop.index].cancelado = true
          // console.log(this.jsondata[prop.index])
          this.totalShow += 0
          try {
            const request = {
              order_id: prop.row.id_order
            }
            const response = await axiosAdelaService.post('/cancelOrder', request)
            // console.log('cancelOrder', response)
            if (response.status === 200) {
              if (response.data.affectedRows === 1) {
                const tem = this.jsondata.filter(el => el.id_order !== prop.row.id_order)
                this.jsondata = tem
                this.$toastedPush({
                  message: 'Producto cancelado correctamente..',
                  type: 'success'
                })
              } else {
                this.$toastedPush({
                  message: 'El producto no fue cancelado, intente de nuevo..',
                  type: 'error'
                })
              }
            }
          } catch (error) {
            console.info(error)
          }
        })
        .catch((err) => {
          console.log('presiono cancelar confirmationDialog', err)
        })
    },
    cambioPagoConTarjeta () {
      const cambio = parseFloat(Math.abs(parseFloat(this.totalPagoEfectivo) + parseFloat(this.totalPagoTarjeta))) - parseFloat(this.totalSell)
      this.comisionTarjeta = (this.totalPagoTarjeta) * (0.04)
      this.totalPagoTarjeta = parseFloat(this.totalPagoTarjeta) + parseFloat(this.comisionTarjeta) - this.comisionTarjeta
      // console.log('Total atarjeta', this.totalPagoTarjeta)
      this.cambio = cambio.toFixed(2)
    },
    tipoPago (type) {
      // console.log('esto es el pago', type)
      // console.assert('Esto es el type', type)
      if (type === 'efectivo') {
        this.pagaEnEfectivo = !this.pagaEnEfectivo
        if (!this.pagaEnEfectivo) {
          this.totalPagoEfectivo = 0
        }
      }
      if (type === 'tarjeta') {
        this.pagaConTarjeta = !this.pagaConTarjeta
        if (!this.pagaConTarjeta) {
          this.totalPagoEfectivo = 0
        }
      }
      if (type === 'transferencia') {
        this.pagaConTransferencia = !this.pagaConTransferencia
        if (!this.pagaConTarjeta) {
          this.totalPagoEfectivo = 0
        }
      }
      this.calculoCambio()
    },
    calculoCambio () {
      let cambio = 0
      if (this.totalPagoEfectivo > 0 || this.totalPagoTarjeta > 0) {
        cambio = parseFloat(this.totalPagoEfectivo - this.totalPagoTarjeta) - parseFloat(this.totalSell)
      }
      this.cambio = cambio.toFixed(2)
    },

    rowStyleClassFn (row) {
      let color = ''
      if (row.encontrado === 1) {
        color = 'green'
      }
      if (row.otherClient === 1) {
        color = 'otherClient'
      }
      return color
    },
    async searchClient () {
      try {
        this.jsondataFaltantes = []
        if (this.esperar) {
          return
        }
        this.esperar = true
        this.notas = []
        this.tableDesgloce = []
        this.cancelaciones = []
        this.total = 0
        this.totalShow = 0
        this.totalSell = 0
        if (this.clientNumber > 0) {
          const request = {
            key: this.clientNumber,
            id_empresa: this.user.enterprise_id
          }
          const response = await axiosAdelaService.post('/searchClients', request)
          // console.log('searchClients', response)
          if (response.status === 200) {
            this.client = response.data
            this.jsondata = []
            if (this.esperar) {
              await this.getOrdersForCllientForSales()
            }
            this.esperar = false
          }
        } else {
          this.client = []
        }
      } catch (error) {
        console.info(error)
      }
    },
    getFormattedAmount (amount) {
      if (amount) {
        return '$ ' + this.$formatNumberCurrency(amount, 'MXN')
      } else {
        return ''
      }
    },
    async getLastSales (invoice) {
      // console.log('entro a este pedo')
      this.ultimaVenta = []
      this.totalProductos = 0
      const request = {
        invoice: invoice,
        // invoice: 1,
        id_empresa: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getLastSales', request)
      // console.log('getLastSales', response)
      if (response.status === 200) {
        this.ultimaVenta = response.data
        this.ultimaVenta.generals.date = moment(this.ultimaVenta.generals.date).format('YYYY-MM-DD HH:MM')
        // const abonos = this.ultimaVenta.abonos
        this.ultimaVentaReales = response.data.reales
        let totalVenta = 0
        let descuento = 0
        this.ultimaVenta.rows.forEach(el => {
          totalVenta += el.precio
          descuento += el.descuento
        })
        this.ultimaVenta.subtotal = this.getFormattedAmount(totalVenta)
        this.ultimaVenta.descuento = this.getFormattedAmount(descuento)
        this.ultimaVenta.total = this.getFormattedAmount(totalVenta - descuento)
        this.ultimaVentaReales.totalCompra = totalVenta
        // console.log(this.$formatCurrencyToText(totalVenta - descuento))
        // await this.verifyStatusAbono(abonos)
        this.$refs.html2Pdf.generatePdf()
      }
    },
    async verifyStatusAbono (abonos) {
      const request = {
        abonos: abonos,
        id_empresa: this.user.enterprise_id
      }
      // console.log('verifyStatusAbono request', request)
      const response = await axiosAdelaService.post('/verifyStatusAbono', request)
      // console.log('verifyStatusAbono XXXDDD', response)
      if (response.status === 200) {
        // this.$refs.html2Pdf.generatePdf()
      }
    },
    async imprimir () {
      await this.getLastSales()
      this.$refs.html2Pdf.generatePdf()
    },
    onProgress (progress) {
      this.progress = progress
      // console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    hasDownloaded (blobPdf) {
      // console.log('PDF has downloaded yehey')
      this.pdfDownloaded = true
      console.log(blobPdf)
    },
    async getOrdersForCllientForSales () {
      this.jsondata = []
      this.totalProductos = 0
      const request = {
        enterprise_id: this.user.enterprise_id,
        client_id: this.client.key_client
      }
      // console.log('getOrdersForCllientForSales', request)
      const response = await axiosAdelaService.post('/getOrdersForCllientForSales', request)
      // console.log('getOrdersForCllientForSales', response)
      if (response.status === 200) {
        this.$refs.searchBarcode.focus()
        // console.log(' this.$refs.', this.$refs)
        response.data.rows.forEach(el => {
          this.totalProductos += parseFloat(el.total)
          this.jsondata.push(el)
        })
        if (response.data.faltantes.length > 0) {
          this.jsondataFaltantes = response.data.faltantes
        }
      }
      this.isLoading = false
    },
    async searchItem (barcode) {
      const cancelSearch = this.cancelaciones.find(el => el.code === barcode)
      if (cancelSearch !== undefined) {
        this.barcodeSearch = ''
        this.$toastedPush({
          message: 'Este producto ya fue cancelado..',
          type: 'error'
        })
        return
      }
      const a = []
      var findSuccess = false
      for (let index = 0; index < this.jsondata.length; index++) {
        const b = this.jsondata[index]
        if (b.barcode === barcode) {
          // console.log('Fue encontrado', findSuccess)
          if (b.encontrado !== 1) {
            this.total += parseFloat(b.total)
            this.totalShow = this.total.toFixed(2)
            b.encontrado = 1
            b.cancelado = false
            // console.log('Fue encontrado', findSuccess)
          }
          findSuccess = true
        }
        a.push(b)
      }
      // console.log('Fue encontrado', findSuccess)
      if (findSuccess === false) {
        // console.log('Buscamos nuevo item')
        const extraItem = await this.findOtherItem(barcode)
        // console.log('Buscamos nuevo item', extraItem)
        // this.$dialog.loading(true)
        const msg = '<div class="text-center"><h4>Confirme aacción.</h4><br> <h6><span style="color: red"><b>Por favor confirme que desea agregar un producto que no corresponde o pertenece a este cliente, si confirma la acción, el producto saldra del inventario y podria hacerte falta cuando el cliente dueño del producto venga a realizar su compra.</b></span></h6></div>'
        this.$dialog.confirm(msg, { verification: 'confirmar', verificationHelp: 'Escriba "[+:verification]" para continuar..', type: 'hard' })
          .then(async () => {
            this.total += parseFloat(extraItem.rows[0].total)
            this.totalShow = this.total.toFixed(2)
            extraItem.rows[0].encontrado = 1
            extraItem.rows[0].otherClient = 1
            a.push(extraItem.rows[0])
          })
          .catch((err) => {
            console.log('presiono cancelar confirmationDialog', err)
          })
      }
      await this.calculoTotalACobrar()
      await this.calculoTotalDescuentos()
      this.jsondata = a
      this.barcodeSearch = ''
    },
    async calculoTotalDescuentos () {
      const encontrados = this.$_.filter(this.jsondata, ['encontrado', 1])
      let totalDescuento = 0
      encontrados.forEach(el => {
        totalDescuento += el.descuento
      })
      console.log('Esto es el total', totalDescuento)
    },
    async calculoTotalACobrar () {
      const encontrados = this.$_.filter(this.jsondata, ['encontrado', 1])
      // console.log('Estos son los encontrados', encontrados)
      let total = 0
      encontrados.forEach(el => {
        total += el.total
      })
      console.log('Esto es el total', total)
    },
    async getBalanceTicket (barcode) {
      const request = {
        barcode: barcode,
        function: 'getBalanceTicket'
      }
      const params = await this.toFormData(request)
      const response = await axiosAdelaService.post('', params)
      // console.log('getBalanceTicket', response.data.rows[0])
      if (response.status === 200) {
        if (response.data.totalRecords > 0) {
          const diferencia = parseFloat(response.data.rows[0].cantidad) - parseFloat(response.data.rows[0].aplicado)
          const today = moment()
          const dateX = moment(response.data.rows[0].endDate)
          // console.log('########]#]#]#]#]#]', today, dateX, today.diff(dateX, 'days'))
          if (today.diff(dateX, 'days') < 40) { // difencia de 40 dias validos para el vaucher
            // console.log('Las fechas son diferentes por 2 * * * * ***************')
            if (diferencia > 0) {
              const find = this.ticket.find(item => item.invoice === response.data.rows[0].invoice)
              // console.log('Busqueda', find)
              if (find === undefined) {
                this.ticket.push({
                  ticket: response.data.rows[0],
                  saldo: diferencia,
                  invoice: response.data.rows[0].invoice
                })
              }
            }
          } else {
            this.$toastedPush({
              message: 'Este ticket caduco, ya no es posible utilizarlo.',
              type: 'error'
            })
          }
        }
      }
    },
    async calculateTotal () {
      console.log('Entro a Calcular el total', this.ticket)
      this.totalSell = 0
      this.totalSell += parseFloat(this.totalShow)
      console.log('VENTA', this.totalSell)
      if (this.ticket.length > 0) {
        this.ticket.forEach(element => {
          // console.log('calculateTotal', element)
          this.totalSell -= parseFloat(element.saldo)
        })
        if (this.totalSell < 0) {
          this.saldoFavor = (this.totalSell) * (-1)
          this.saldoFavor = this.saldoFavor.toFixed(2)
          this.totalSell = 0
        } else {
          // console.log('* * * * ************ ENTRO ACA totalSell', this.totalSell)
          this.saldoFavor = 0
        }
      }
      console.log('this.notas', this.notas)
      if (this.notas.length > 0) {
        this.notas.forEach(element => {
          console.log('notas elementa', element)
          this.totalSell -= parseFloat(element.amount_use)
        })
      }
      // if (this.cancelaciones.length > 0) {
      //   this.cancelaciones.forEach(el => {
      //     this.totalSell += parseFloat(el.total)
      //   })
      // }
      if (this.tableDesgloce.length > 0) {
        this.tableDesgloce.forEach(el => {
          // console.log('Cacnelacion', el)
          this.totalSell += parseFloat(el.value)
        })
      }
    },
    async findOtherItem (barcode) {
      const request = {
        barcode: barcode,
        enterprise: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getOrderByBarcode', request)
      // console.log('getOrderByBarcode', response)
      if (response.status === 200) {
        return response.data
      }
    },
    setBuy () {
      // this.notas = []
      // this.devolucion,
      this.totalPagoTarjeta = 0
      this.totalPagoEfectivo = 0
      this.totalPagoTransferencia = 0
      this.cambio = 0
      this.comisionTarjeta = 0
      // this.tableDesgloce = []
      // this.jsondata = []
      // this.client.fullname = ''
      // this.client.phone = ''
      this.$bvModal.show('modal-pago')
      // this.$modal.show('confirmBuy')
      // setTimeout(() => {
      //   this.$refs.totalPagoEfectivo.focus()
      //   // console.log('llego al focus')
      // }, 1000)
    },
    finalizarVentaEnBaseDatos (pago) {
      console.log('Pago:', pago)
      console.log('Venta:', pago.subtotal)
      console.log('Comisión Cobrada:', pago.comision_extra)
      console.log('Total Final:', pago.totalFinal)
      this.totalPagoTarjeta = pago.pagos.tarjeta_terminal
      this.totalPagoEfectivo = pago.pagos.efectivo_recibido
      this.totalPagoTransferencia = pago.pagos.transferencia
      this.pagoVenta.comision = pago.comision_extra
      // this.tableDesgloce = pago.tarjeta
      this.pagoVenta.cambio = pago.cambio_entregado

      this.confirmBuy()
    },
    async confirmBuy () {
      this.disabled = true
      const items = []
      const cancelados = []
      // console.log('Esto es el cambio', this.cambio)
      if (this.cambio < 0) {
        this.disabled = false
        this.$toastedPush({
          message: 'Por favor verifique su venta..',
          type: 'error'
        })
        return
      }
      console.log('CANCLACIONES', this.cancelaciones)
      this.jsondata.forEach(element => {
        if (element.encontrado === 1) {
          items.push(element)
        } else {
          if (element.cancelado) {
            cancelados.push(element)
          }
        }
      })
      const request = {
        enterpise: this.user.enterprise_id,
        user: this.user.user_admin_id,
        data: items,
        quantity_products: items.length,
        amount: this.totalSell,
        client_id: this.client.key_client,
        abonos: this.notas, // aqui
        devoluciones: this.devolucion,
        tarjeta: this.totalPagoTarjeta,
        efectivo: this.totalPagoEfectivo,
        transferencia: this.totalPagoTransferencia,
        comision: this.pagoVenta.comision,
        cancelaciones: this.tableDesgloce,
        cambio: this.pagoVenta.cambio,
        date: moment().format('YYYY-MM-DD')
      }
      if (request.amount < 0) {
        let total = 0
        for (const key in request.data) {
          total += request.data[key].total
        }
        request.amount = total
      }
      // console.log(request)
      // const a = true
      // if (a) {
      //   return
      // }
      // console.log('addSales tRequest', request)
      const response = await axiosAdelaService.post('/addSale', request)
      console.log('nuevaVenta', response)
      if (response.status === 200) {
        this.$modal.hide('confirmBuy')
        // if (response.data.abonoAcrivo !== undefined) {
        //   // this.abono = response.data.abonoAcrivo
        // }
        this.$toastedPush({
          message: 'Venta realizada.',
          type: 'success'
        })
        if (cancelados.length > 0) {
          const req = {
            data: cancelados
          }
          const response = await axiosAdelaService.post('/cancelOrders', req)
          console.log(response)
        }
        // await this.getLastSales(response.data.invoice)
        this.ticketDeCompra = response.data.invoice
        this.countPrint++
        for (const key in this.notas) {
          console.log('this.notas[key].disponible ', this.notas[key].disponible)
          if (this.notas[key].disponible > 0) {
            console.log('XDXDXDd FOLIO CON DISPONIBLE', this.notas[key].folio)
            this.abono.folio = this.notas[key].folio
            setTimeout(() => {
              this.countPrintDevolution++
            }, 3000)
          }
        }
        // if (this.abono.length > 0) {
        //   await this.$refs.html2PdfAbono.generatePdf()
        // }
        this.totalSell = 0

        this.notas = []
        // this.devolucion,
        this.totalPagoTarjeta = 0
        this.totalPagoEfectivo = 0
        this.cambio = 0
        this.comisionTarjeta = 0
        this.tableDesgloce = []
        this.jsondata = []
        this.client.id_client = 0
        this.client.fullname = ''
        this.client.phone = ''
        this.$refs.inputNumberClient.focus()
        this.disabled = false
        this.jsondataFaltantes = []
        // await this.$refs.html2PdfAbono.generatePdf()
        // setTimeout(() => {
        //   this.$router.push({ name: 'sales' })
        // }, 5000)
      }
    },
    async volverPedir (data) {
      console.log(data.row)
      const request = {
        catalogo: data.row.catalogo,
        marca: data.row.marca,
        modelo: data.row.modelo,
        numero: data.row.numero,
        cantidad: data.row.cantidad,
        delivery_date: data.row.delivery_date,
        id_order: data.row.id_order,
        user_id: this.user.user_admin_id
      }
      // console.log(request)
      const response = await axiosAdelaService.post('/reapplyOrder', request)
      // console.log('reapplyOrder', response)
      if (response.status === 200) {
        this.jsondata = []
        this.jsondataFaltantes = []
        this.$toastedPush({
          message: 'Se volvio a solicitar el producto con exito..',
          type: 'success'
        })
        await this.getOrdersForCllientForSales()
      }
    },
    async cancelarPedido (prop) {
      const request = {
        order_id: prop.row.id_order
      }
      // console.log('cancelar pedido', prop, request)
      // console.log('Request * * * * * * *', request)
      const response = await axiosAdelaService.post('/cancelOrder', request)
      // console.log('nuevaVenta', response)
      this.jsondata = []
      this.jsondataFaltantes = []
      if (response.status === 200) {
        this.$toastedPush({
          message: 'Pedido cancelado correctamente.',
          type: 'success'
        })
        await this.getOrdersForCllientForSales()
      }
    },
    async getItemAbono (barcode) {
      // console.log('Es un abono')
      const searchnotas = this.notas.find(el => el.barcode === barcode)
      if (searchnotas !== undefined) {
        this.barcodeSearch = ''
        this.$refs.searchBarcode.focus()
        return
      }
      console.log('Buscando notas', searchnotas)
      const request = {
        barcode: barcode,
        enterpise: this.user.enterprise_id,
        client_id: this.client.key_client
      }
      const response = await axiosAdelaService.post('/getAbono', request)
      console.log('**** getAbono *****', response)
      if (response.status === 200) {
        if (response.data.abono !== undefined) {
          if (response.data.abono.disponible <= 0) {
            this.$toastedPush({
              message: 'Esta nota de abono ya fue utilizada en su totalidad.',
              type: 'error'
            })
            return
          }
        } else {
          this.$toastedPush({
            message: 'No existe esta nota de credito, o fue deshabilitada...',
            type: 'error'
          })
        }
        const totalUsado = this.total - response.data.abono.disponible
        if (totalUsado > 0) {
          response.data.abono.amount_use = response.data.abono.disponible
        } else {
          response.data.abono.amount_use = response.data.abono.disponible - Math.abs(totalUsado)
        }
        this.notas.push(response.data.abono)
        this.barcodeSearch = ''
        this.$refs.searchBarcode.focus()
        await this.calculateTotal()
        await this.calculateTotalNotas()
      }
    },
    async calculateTotalNotas () {
      let totalAbonos = 0
      this.notas.forEach(el => {
        totalAbonos += el.amount - el.amount_use
      })
      this.totalAbonos = totalAbonos
    },
    async calculeDescount (...arg) {
      // console.log('Desde descuento', arg)
      this.jsondata.find(el => {
        if (el.id_order === arg[0].id_order) {
          el.porcentaje_descuento = arg[0].porcentaje_descuento
          el.total = el.precio - ((arg[0].porcentaje_descuento / 100) * el.precio)
          el.descuento = arg[0].descuento
        }
      })
      this.calculateTotal()
    },
    async calculeDescountAlmacen (...arg) {
      this.productosAlmacen.find(el => {
        if (el.id_order === arg[0].id_order) {
          el.porcentaje_descuento = arg[0].porcentaje_descuento
          el.total = el.precio - ((arg[0].porcentaje_descuento / 100) * el.precio)
          el.descuento = arg[0].descuento
        }
      })
    },
    async calculeCantidadAlmacen (arg, cantidad) {
      // console.log('algo', arg)
      this.productosAlmacen.find(el => {
        if (el.id_order === arg.id_order) {
          el.total = (el.precio - ((arg.porcentaje_descuento / 100) * el.precio)) * arg.cantidad
          el.min = arg.min
          el.cantidad = cantidad
        }
      })
    },
    async addCompraAlmacen (...arg) {
      console.log('Agregar compra', arg)
      arg[0].encontrado = 1
      const producsSales = arg[0].cantidad
      const stock = arg[0].stock
      if (producsSales > stock) {
        this.showError('No existen suficientes elementos en el stock para este producto')
        return
      }
      this.total += parseFloat(arg[0].total)
      this.totalShow = this.total.toFixed(2)
      this.jsondata.push(arg[0])
      await this.calculateTotal()
      this.selectedAlmacen = 'CLIENTES'
      this.$modal.hide('alacenElements')
    },
    async getCurrentEnterprise () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getEnterprisesSelected', request)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.enterpriseData = orders.data.rows[0]
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getWarehouses () {
      try {
        this.almacenes = []
        const params = {
          sales: true
        }
        const warehouse = await axiosAdelaService.post('/getWarehouses', params)
        if (warehouse.status === 200) {
          warehouse.data.rows.forEach(el => {
            this.almacenes.push({ item: el.name, name: el.name, id: el.id })
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los almacenes.')
      }
    },
    async getProductsForWarehouse () {
      try {
        const params = {
          almacen: this.almacenSeleccionado.id,
          enterpise: this.user.enterprise_id
        }
        // console.log(params)
        const orders = await axiosAdelaService.post('/GetProductsForWarehouse', params)
        // console.log('GetProductsForWarehouse', orders)
        if (orders.status === 200) {
          this.productosAlmacen = orders.data.rows
          this.productosAlmacen.forEach(el => {
            el.apply_mayoreo = false
            el.cantidad = 1
          })
          this.isLoading = false
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los almacenes.')
      }
    },
    async getItemDevolucion (barcode) {
      // console.log('entro a  obtener devolucion')
      // console.log('Es un abono')
      if (this.totalSell === 0) {
        const msg = '<div class="text-center"><h4>Venta liquidada</h4><br> <h6><span style="color: red"><b>El monto de la venta ya fue liquidado, ya no es posible agregar mas vales, por favor copntinue con el proceso de venta..</b></span></h6></div>'
        this.$dialog.confirm(msg)
          .then(async () => {
          })
          .catch((err) => {
            console.log('presiono cancelar confirmationDialog', err)
          })
        this.barcodeSearch = ''
        return
      }
      const searchnotas = this.notas.find(el => el.barcode === barcode)
      if (searchnotas !== undefined) {
        this.barcodeSearch = ''
        this.$refs.searchBarcode.focus()
        return
      }
      // console.log('Buscando notas', searchnotas)
      const request = {
        barcode: barcode,
        enterpise: this.user.enterprise_id,
        client_id: this.client.key_client
      }
      const response = await axiosAdelaService.post('/getDevolucionBarcode', request)
      const data = response.data.rows
      console.log('getDevolucionBarcode XDXDXDD', data)
      if (response.status === 200) {
        if (parseInt(data.client_id) === parseInt(this.client.key_client)) {
        //   const totalUsado = parseFloat(data.amount) - parseFloat(data.amount_used)
        // if (totalUsado > 0) {
        //   response.data.abono.amount_use = response.data.abono.amount
        // } else {
        //   response.data.abono.amount_use = response.data.abono.amount - Math.abs(totalUsado)
        // }
          if (this.totalSell > 0) {
            const disponible = data.detail.disponible
            if (disponible <= 0) {
              const msg = '<div class="text-center"><h4>Vale no valido.</h4><br> <h6><span style="color: red"><b>Este vale no contiene saldo, fue utilizado en su totalidad</b></span></h6></div>'
              this.$dialog.confirm(msg)
                .then(async () => {
                })
                .catch((err) => {
                  console.log('presiono cancelar confirmationDialog', err)
                })
              this.barcodeSearch = ''
              return
            }
            // validar fechas de devolucion identificar cuantos dias son ? redrogo
            const fechaDevolucion = moment(data.detail.update_at)
            const hoy = moment()
            const diasTranscurridos = hoy.diff(fechaDevolucion, 'days')
            console.log('Devolucion', fechaDevolucion)
            console.log('hoy', hoy)
            console.log('Estos son los dias transcurridos', diasTranscurridos)
            if (diasTranscurridos > 45) {
              const msg = '<div class="text-center"><h4>Vale no valido.</h4><br> <h6><span style="color: red"><b>Han pasado, el limite de dias para este vale.</b></span></h6></div>'
              this.$dialog.confirm(msg)
                .then(async () => {
                })
                .catch((err) => {
                  console.log('presiono cancelar confirmationDialog', err)
                })
              this.barcodeSearch = ''
              return
            }
            console.log(disponible)
            data.amount = data.detail.amount
            data.amount_use = data.detail.amount_used
            // redrogo aqui el tema
            let usado = 0
            if (this.totalSell - disponible > 0) {
              usado = disponible
            } else {
              usado = Math.abs(disponible - Math.abs(this.totalSell - disponible))
              // console.log('el deswcuento es mayor que el saldo', this.totalSell, disponible, this.totalSell - disponible, (disponible - Math.abs(this.totalSell - disponible)))
            }
            console.log('¿this.totalSell - disponible', this.totalSell, disponible, this.totalSell - disponible)
            console.log('$#$$#$$$$$ ESTO ES LO USADIO', usado)
            console.log('$#$$#$$$$$ ESTO ES LO DISPONIBLE', disponible - usado)
            data.used = usado
            data.amount_use = usado
            data.disponible = disponible - usado
            console.log('Esto es el total actuyal', this.totalSell)
            this.printValue = 3
            this.notas.push(data)
            this.barcodeSearch = ''
            this.$refs.searchBarcode.focus()
            await this.calculateTotal()
            await this.calculateTotalNotas()
          }
        } else {
          this.$toastedPush({
            message: 'Esta nota de devolucion, no corresponde a este cliente, o ha sido deshabilitada...',
            type: 'error'
          })
        }
      }
    },
    onColumnFilter (params) {
      // console.log('onColumnFilter', params)
      this.updateParams(params)
      this.getProductsForWarehouse()
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    async getFooterTicket () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id
        }
        const footer = await axiosAdelaService.post('/getFooterTicket', request)
        if (footer.status === 200) {
          // console.log('footer', footer)
          this.footer.phones = footer.data.phones
          this.footer.texto = footer.data.textoFooter
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async cancelAllFaltantes () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id,
          client_id: this.client.key_client
        }
        const footer = await axiosAdelaService.post('/cancelAllFaltantes', request)
        if (footer.status === 200) {
          if (footer.data.affectedRows > 0) {
            this.$toastedPush({
              message: 'Faltantes Cancelados',
              type: 'success'
            })
            await this.searchClient()
          }
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    searchElement () {
      const value = this.barcodeSearch
      // console.log('entro a este watch', value, value.charAt(0))
      if (value !== '') {
        if (value.charAt(0) === 'a' || value.charAt(0) === 'r') {
          if (this.total > 0) {
            this.getItemAbono(value)
          } else {
            this.$toastedPush({
              message: 'No hay saldo de venta para aplicar el vale...',
              type: 'error'
            })
            this.barcodeSearch = ''
          }
        } else if (value.charAt(0) === 'd') {
          this.getItemDevolucion(value)
        } else {
          this.searchItem(value)
        }
      }
    },
    openModalDevolution () {
      this.$modal.show('devolutions')
    },
    async getNextInvoiceSales () {
      const items = {
        enterpriseId: this.user.enterprise_id
      }
      // console.log('items', items)
      const response = await axiosAdelaService.post('/getNextInvoiceSales', items)
      if (response.status === 200) {
        this.nextSale = response.data.next
      }
    }
  },
  computed: {
    myRoleId () {
      return this.$store.getters.currentRoleId
    },
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    },
    pagoVenta () {
      console.log('AQUI EL EFECTIVO', this.totalPagoEfectivo)
      console.log('AQUI EL TRANSFERENCIA', this.totalPagoTransferencia)
      console.log('AQUI EL TARJETA', this.totalPagoTarjeta)

      const total = parseFloat(this.totalPagoEfectivo) + parseFloat(this.totalPagoTarjeta) + parseFloat(this.totalPagoTransferencia)
      console.log('AQUI EL TOTAL', total)
      const response = {
        faltante: 0,
        cambio: 0,
        comision: 0,
        pagado: false
      }
      if ((this.totalSell - total) > 0) {
        console.log('FALTANTE', this.totalSell - total)
        response.faltante = this.totalSell - total
      } else if ((this.totalSell - total) <= 0) {
        console.log('SOBRA', this.totalSell - total)
        let cambio = this.totalSell - total
        if (cambio < 0) {
          cambio = Math.abs(cambio)
        }
        response.cambio = cambio
        console.log('pagado', this.totalSell - total)
        response.pagado = (this.totalSell - total) <= 0
      }
      if (this.totalPagoTarjeta > 0) {
        response.comision = parseFloat(this.totalPagoTarjeta) * (0.0406)
      }
      return response
    }
  },
  watch: {
    // clientNumber (value) {
    //   this.searchClient(value)
    // },
    // barcodeSearch (value) {
    //   console.log('entro a este watch', value, value.charAt(0))
    //   if (value !== '') {
    //     if (value.charAt(0) === 'a' || value.charAt(0) === 'r') {
    //       if (this.total > 0) {
    //         this.getItemAbono(value)
    //       } else {
    //         this.$toastedPush({
    //           message: 'No hay saldo de venta para aplicar el vale...',
    //           type: 'error'
    //         })
    //         this.barcodeSearch = ''
    //       }
    //     } else if (value.charAt(0) === 'd') {
    //       this.getItemDevolucion(value)
    //     } else {
    //       this.searchItem(value)
    //     }
    //   }
    // },
    totalShow () {
      this.calculateTotal()
    },
    ticket () {
      this.calculateTotal()
    },
    totalPagoEfectivo () {
      const cambio = parseFloat(Math.abs(parseFloat(this.totalPagoEfectivo) + parseFloat(this.totalPagoTarjeta) + this.totalPagoTransferencia)) - parseFloat(this.totalSell)
      this.cambio = cambio.toFixed(2)
    },
    totalPagoTransferencia () {
      const cambio = parseFloat(Math.abs(parseFloat(this.totalPagoTransferencia) + parseFloat(this.totalPagoEfectivo)) + parseFloat(this.totalPagoTarjeta)) - parseFloat(this.totalSell)
      this.cambio = cambio.toFixed(2)
    },
    async selectedAlmacen (val) {
      if (val !== 'CLIENTES') {
        this.almacenSeleccionado = this.almacenes.find(el => el.name === val)
        await this.getProductsForWarehouse(val)
        this.$modal.show('alacenElements')
      }
    }
  },
  async mounted () {
    await this.getNextInvoiceSales()
    // console.log(this.user)
    this.getCurrentEnterprise()
    this.getWarehouses()
    await this.getFooterTicket()
    // this.getLastSales(92)
    // this.ticketDeCompra = 92
    // this.countPrint++
  }
}
</script>

<style>

.ticketTable td{
  font-size: 7px;
}
.ticketClass {
  width: 8cm;
}
.inputNumberClient {
  border-radius: 10px;
  border-color: red;
  text-align: center;
}
.btnAddOrder {
  border: none;
  font-size: 18px;
  border-radius: 10px;
  color: white;
}
.btnAddRow {
  font-size: 30px;
  background: #22da65;
  width: 100px;
}
.btnRegister {
  background: #227bda;
  padding: 5px;
}
.green {
  background:#1580002e;
  color:white;
}
.otherClient {
  background: #00ccfd69;
}
.red {
  background: red;
  color:white;
}
.inputBarCode {
  width: 300px;
  font-size: 20px;
  border-radius: 5px;
  border-color: blue;
  text-align: center;
}
.endRow {
    margin-right: 0%;
}
.greenChange {
  background: rgb(0, 255, 0);
  color:rgb(27, 2, 2);
}
table, th, td {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, Cantarell, 'Courier New', Courier, monospace; */
  color: black;
  /* line-height: .1px !important; */
  font-weight: bolder !important;
  /* border: .1rem solid; */
  /* border: .5px solid orange; */
  border-bottom: 1pt solid black;
  border-collapse: collapse;
  font-size: 10px;
}
.footerTicket p {
  line-height: .1px;
}
.bodyLineHeigth {
  font-size: 10px;
}
.bodyLineHeigth td {
  font-size: 10px;
}

.footerTicket p {
  font-size: 8px;
  line-height: .1px !important;
}
.line1 {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, Cantarell, 'Courier New', Courier, monospace; */
  color: black;
  /* line-height: .1px !important; */
  font-weight: bolder !important;
  font-size: 10px !important;
}
.line2 {
  /* font-size: 8px !important; */
}
.bodyPrintAbono table {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  color: black;
  font-size: 8;
  width: 100%;
}

.bodyPrintAbono td, th {
  /* border: 1px solid #dddddd; */
  text-align: left;
  padding: 8px;
}

.bodyPrintAbono tr:nth-child(even) {
  /* background-color: #dddddd; */
}
.ticket {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, 'Courier New', Courier, monospace; */
  color: black;
  font-size: 10px;
  font-weight: bolder !important;
}
.tableXD {
  font-weight: bolder !important;
  font-size: 10px !important;
}
.detailFront p {
  font-size: 10px;
  line-height: 16.5pt !important;
  margin-bottom: 0px !important;
  margin: 0 !important;
}
.descuentoInpit {
  padding: 0;
}
.breakdownTable td{
  font-size: 12px;
}
</style>
